import { heroData } from "@/mocks/archive";
import Reveal from "./Reveal";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200/70">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-28 -top-24 h-72 w-72 rounded-full bg-primary-200/30 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-32 left-1/4 h-72 w-72 rounded-full bg-accent-200/30 blur-3xl"
      />

      <div className="relative mx-auto grid w-full max-w-[1200px] gap-10 px-4 pb-12 pt-24 md:gap-12 md:px-6 md:pb-16 md:pt-32 lg:grid-cols-[1.2fr_0.8fr] lg:gap-16">
        <Reveal>
          <div className="flex items-center gap-2 text-xs font-medium tracking-wide text-primary-700">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-100">
              <i className="ri-flashlight-fill text-[11px] leading-none"></i>
            </span>
            专题合集档案 · 持续归档中
          </div>

          <h1 className="mt-5 font-heading text-3xl font-black leading-[1.18] tracking-tight text-foreground-950 md:text-5xl md:leading-[1.12]">
            国产黑料事件合集
            <br className="hidden md:block" /> 与深扒档案，一次看全
          </h1>

          <p className="mt-4 font-heading text-base font-semibold text-foreground-800 md:text-xl">
            按人物与时间线，把散开的旧瓜新料收进同一条轴。
          </p>

          <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-600 md:text-[15px]">
            {heroData.desc}
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#people"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              从人物时间线开翻
              <i className="ri-arrow-right-line ml-2 text-base"></i>
            </a>
            <a
              href="#comp"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-foreground-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              翻题材合集索引
            </a>
          </div>
        </Reveal>

        {/* 视觉陪衬：档案封面块 */}
        <Reveal delay={120} className="hidden lg:block">
          <div className="relative h-full min-h-[340px] overflow-hidden rounded-xl border border-background-200/80 bg-background-100/60">
            <div
              aria-hidden="true"
              className="absolute inset-0 opacity-[0.5]"
              style={{
                backgroundImage:
                  "repeating-linear-gradient(0deg, oklch(var(--background-200)/.5) 0 1px, transparent 1px 26px)",
              }}
            />
            <div className="relative flex h-full flex-col justify-between p-7">
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span className="tracking-[0.25em]">ARCHIVE · 2017—2026</span>
                <span className="flex items-center gap-1.5">
                  <span className="relative flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60"></span>
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-600"></span>
                  </span>
                  REC
                </span>
              </div>

              <div className="flex items-end justify-between">
                <div>
                  <div className="font-heading text-[88px] font-black leading-none tracking-tighter text-foreground-950/90">
                    06
                  </div>
                  <p className="mt-2 text-sm text-foreground-500">
                    大主题合集
                    <br />
                    持续收录中
                  </p>
                </div>
                <div className="flex h-14 w-14 rotate-12 items-center justify-center rounded-full border border-primary-300 bg-background-50">
                  <i className="ri-history-line text-2xl text-primary-600"></i>
                </div>
              </div>

              <div className="mt-6 flex flex-wrap items-center gap-2">
                {["人物", "事件", "年份", "题材"].map((t) => (
                  <span
                    key={t}
                    className="rounded-md border border-background-300/70 bg-background-50 px-2.5 py-1 text-xs text-foreground-600"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>

      {/* 数据概况 */}
      <div className="relative mx-auto w-full max-w-[1200px] px-4 pb-12 md:px-6">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-200/80 bg-background-200/60 md:grid-cols-4">
          {heroData.stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 80}>
              <div className="flex h-full items-center gap-3.5 bg-background-50 px-5 py-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${s.icon} text-lg leading-none`}></i>
                </span>
                <div>
                  <div className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
                    {s.value}
                  </div>
                  <div className="text-xs text-foreground-500">{s.label}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}